/**
* PURPOSE: Card administrativo para abrir el modal de creación de usuarios.
* RESPONSIBILITIES: Mostrar acción de crear usuario y renderizar ModalCreateUser.
* COLLABORATORS: src/admin/CreateUser/Modal/ModalCreateUser/ModalCreateUser.jsx, src/sections/AdminSection.jsx
* ROUTE: src/admin/CreateUser/CreateUser.jsx
*/
import React, { useState } from "react";
import Button from "@mui/joy/Button";
import Add from "@mui/icons-material/Add";
import ModalCreateUser from "./Modal/ModalCreateUser/ModalCreateUser";

const CreateUser = () => {
  const [openModal, setOpenModal] = useState(false);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  return (
    <>
      <div className="flex-1 rounded-2xl bg-white p-5 dark:bg-gray-600 dark:text-gray-300">
        <div>
          <h5 className="mb-2 text-2xl font-bold font-medium text-gray-700 dark:text-neutral-50">
            Crear Usuario
          </h5>
        </div>
        <div>
          <Button
            startDecorator={<Add />}
            onClick={() => handleOpenModal()}
            style={{ marginBottom: "3.5px" }}
          >
            Añadir Usuario
          </Button>
        </div>
      </div>
      {openModal ? <ModalCreateUser open={openModal} setOpen={setOpenModal} /> : null}
    </>
  );
};

export default CreateUser;
